export default {
  GENERAL: 'general',
  ADVANCED: 'advanced',
};
